import React, { useState, useRef, useEffect } from "react";
import { toast } from "../common/Toast";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../features/user/userSlice";
import { NavLink, useNavigate } from "react-router-dom";
import { getSocket, disconnectSocket } from "../../utils/socket";
import config from "../../config";
import UserNotificationBell from "./UserNotificationBell";

// Removed: fetchFilteredProfiles()/profiles state and its matches-fetch
// useEffect. This called /api/matches/new-matches on every single page
// load, but its only consumer — the badge showing profiles.length on the
// Matches nav item — is commented out below, so the result was never
// displayed anywhere. It's also the source of the
// "GET /api/matches/new-matches?looking_for=... 500" error showing up in
// the console constantly — matrimony matching code left over from before
// the Future Family pivot, unused and now broken since looking_for is
// optional/nullable rather than a required field every user has.
const Header = ({ unreadNotificationCount }) => {
  const [showHelp, setShowHelp] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [activeTab, setActiveTab] = useState(""); // manual active tab
  // FIXED: mobile nav toggle no longer relies on Bootstrap's
  // data-bs-toggle/data-bs-target JS data-API. Whatever bootstrap.bundle.min.js
  // is actually deployed on the server behaves like Bootstrap 4 (confirmed
  // earlier — window.bootstrap.Modal has no getInstance, a Bootstrap-5-only
  // method), and Bootstrap 4 listens for data-toggle/data-target with no
  // "bs-" prefix. The button's click did nothing because the loaded
  // library's data-API was never listening for data-bs-toggle at all. This
  // toggles the same "show" CSS class manually instead, which works
  // identically regardless of which Bootstrap version ends up on the server.
  const [mobileOpen, setMobileOpen] = useState(false);
  const helpRef = useRef(null);
  const profileRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);

  const handleLogout = () => {
    const socket = getSocket();
    if (socket && socket.connected) {
      const userId = user?.id || user?.user_id;
      if (userId) {
        socket.emit("userOffline", { userId });
      }
    }
    disconnectSocket();
    navigate("/login");
    toast.success("Logged out successfully!");
    setTimeout(() => {
      dispatch(clearUser());
    }, 1000);
  };

  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (helpRef.current && !helpRef.current.contains(event.target)) {
        setShowHelp(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar navbar-expand-lg topbar dashboard">
      <div className="container-fluid px-4 px-md-4">
        <NavLink className="navbar-brand" to="/">
          <div className="logo">
            <img src="/images/logo_white.png" alt="Future Family" />
          </div>
        </NavLink>
        <button
          className="navbar-toggler text-white"
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${mobileOpen ? "show" : ""}`} id="shaadiNav">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3  text-start text-lg-center ">
            <li className="nav-item">
              <NavLink
                className="nav-link text-white"
                to="/dashboard"
                title="My Profile"
                onClick={() => setActiveTab("")}
              >
                Profile
              </NavLink>
            </li>
            {/* <li className="nav-item position-relative">
              <NavLink
                className="nav-link text-white"
                to="/matches"
                title="View Matches"
                onClick={() => setActiveTab("")}
              >
                Matches
                <span className="badge bg-white text-dark rounded-pill position-absolute top-0 start-100 translate-middle">
                  {profiles.length}
                </span>
              </NavLink>
            </li> */}
            {/* <li className="nav-item">
              <NavLink
                className="nav-link text-white"
                to="/search-profile"
                title="Search Profiles"
                onClick={() => setActiveTab("")}
              >
                Search
              </NavLink>
            </li>
              <li className="nav-item position-relative">
              <NavLink
                className="nav-link text-white"
                to="/meeting"
                title="Inbox Messages"
                onClick={() => setActiveTab("")}
              >
                Meeting
                {unreadNotificationCount > 0 && (
                  <span className="badge bg-white text-dark rounded-pill position-absolute top-0 start-100 translate-middle">
                    {unreadNotificationCount}
                  </span>
                )}
              </NavLink>
            </li> */}
            <li className="nav-item position-relative">
              <NavLink
                className="nav-link text-white"
                to="/health"
                title="Health"
                onClick={() => setActiveTab("")}
              >
                Health
                {unreadNotificationCount > 0 && (
                  <span className="badge bg-white text-dark rounded-pill position-absolute top-0 start-100 translate-middle">
                    {unreadNotificationCount}
                  </span>
                )}
              </NavLink>
            </li>

            <li className="nav-item position-relative">
              <NavLink
                className="nav-link text-white"
                to="/appointment"
                title="Appointment"
                onClick={() => setActiveTab("")}
              >
                Appointment
                {unreadNotificationCount > 0 && (
                  <span className="badge bg-white text-dark rounded-pill position-absolute top-0 start-100 translate-middle">
                    {unreadNotificationCount}
                  </span>
                )}
              </NavLink>
            </li>


            <li className="nav-item position-relative">
              <NavLink
                className="nav-link text-white"
                to="/continuouscare"
                title="Continuouscare"
                onClick={() => setActiveTab("")}
              >
                Continuouscare
                {unreadNotificationCount > 0 && (
                  <span className="badge bg-white text-dark rounded-pill position-absolute top-0 start-100 translate-middle">
                    {unreadNotificationCount}
                  </span>
                )}
              </NavLink>
            </li>
            {/* <li className="nav-item position-relative">
              <NavLink
                className="nav-link text-white"
                to="/inbox"
                title="Inbox Messages"
                onClick={() => setActiveTab("")}
              >
               Requests
                {unreadNotificationCount > 0 && (
                  <span className="badge bg-white text-dark rounded-pill position-absolute top-0 start-100 translate-middle">
                    {unreadNotificationCount}
                  </span>
                )}
              </NavLink>
            </li> */}

            {/* <li className="nav-item position-relative">
              <NavLink
                className="nav-link text-white"
                to="/identity-enrichment"
                title="Inbox Messages"
                onClick={() => setActiveTab("")}
              >
                Identity Enrichment
                {unreadNotificationCount > 0 && (
                  <span className="badge bg-white text-dark rounded-pill position-absolute top-0 start-100 translate-middle">
                    {unreadNotificationCount}
                  </span>
                )}
              </NavLink>
            </li> */}
          </ul>

          <div className="d-flex align-items-center gap-1 ms-lg-3">
            {/* Notification bell — appointments & reminders, 30 min before */}
           

            <button className="btn btn-sm btn-upgrade" onClick={() => navigate('/upgrade-profile')}>
              <i className="bi bi-gem"></i> {user.plan_name && user.plan_status === "active" ? user.plan_name : "Upgrade Now"}
            </button>

            {/* Help Dropdown */}
            {/* <div className="dropdown" ref={helpRef}>
              <button
                className="btn btn-link text-white text-decoration-none dropdown-toggle"
                onClick={(e) => {
                  e.preventDefault();
                  setShowHelp(!showHelp);
                  setShowProfile(false);
                }}
              >
                Help
              </button>
              {showHelp && (
                <ul className="dropdown-menu dropdown-menu-end show">
                  <li>
                    <NavLink className="dropdown-item" to="#">
                      FAQ
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="#">
                      Contact Support
                    </NavLink>
                  </li>
                </ul>
              )}
            </div> */}

            <div className="v-divider d-none d-lg-block"></div>
 <UserNotificationBell />
            {/* Profile Dropdown */}
            <div className="dropdown" ref={profileRef}>
              <button
                className="btn btn-link d-flex align-items-center dropdown-toggle text-white"
                onClick={(e) => {
                  e.preventDefault();
                  setShowProfile(!showProfile);
                  setShowHelp(false);
                }}
              >
                <img
                  src={
                    user?.profile_image_url ||
                    (user?.profile_image
                      ? `${config.baseURL}/uploads/profiles/${user.profile_image}`
                      : "/images/user.png")
                  }
                  className="rounded-circle"
                  alt="user"
                  height="32"
                  width="32"
                  style={{ objectFit: "cover" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/images/user.png";
                  }}
                />
              </button>
              {showProfile && (
                <ul className="dropdown-menu dropdown-menu-end show">
                  <li><NavLink className="dropdown-item" to="/dashboard" state={{ activtab: "profile" }}>{user.first_name + " " + user.last_name || "Profile"}</NavLink></li>
                  <li><NavLink className="dropdown-item" to="/dashboard" state={{ activtab: "settings" }}>Settings</NavLink></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;